import React from 'react';
import { useTranslation } from 'react-i18next';
import Seo from '../components/Seo';
import { SUPPORTED_LOCALES, type LocaleCode } from '../config/i18n';

/** Viewport-centered shell matching templates/Onboarding Step *.dc.html */
export default function OnboardingShell({
  title,
  children,
  maxWidth = 700,
}: {
  title: string;
  children: React.ReactNode;
  maxWidth?: number;
}) {
  const { t, i18n } = useTranslation();
  const current = SUPPORTED_LOCALES.includes(i18n.language as LocaleCode) ? i18n.language : 'tr';
  const locale: LocaleCode = current === 'en' ? 'en' : 'tr';

  return (
    <div className="relative min-h-screen bg-[#1c1420] font-sans text-[#f5eef7] antialiased">
      <Seo title={`${title} | Loopcast`} description={t('onboarding.seoDescription')} locale={locale} canonicalPath="/onboarding" noindex />

      <div className="absolute right-4 top-4 z-10 flex items-center gap-3 sm:right-6 sm:top-6">
        <div className="flex overflow-hidden rounded-md border border-[#3d2e46] text-xs font-semibold">
          {SUPPORTED_LOCALES.map((code) => {
            const active = current === code;
            return (
              <button
                key={code}
                type="button"
                onClick={() => void i18n.changeLanguage(code)}
                aria-pressed={active}
                className={`px-2.5 py-1.5 uppercase transition-colors ${
                  active ? 'bg-[#ff6f91] text-[#2b0e18]' : 'bg-[#251b2c] text-[#c9b8d1] hover:text-[#f5eef7]'
                }`}
              >
                {code}
              </button>
            );
          })}
        </div>
      </div>

      <div
        className="flex min-h-screen items-center justify-center px-6 py-10 animate-[obSlideIn_0.6s_ease-out]"
        style={{ paddingTop: 56, paddingBottom: 40 }}
      >
        <div className="w-full" style={{ maxWidth }}>
          {children}
        </div>
      </div>

      <style>{`@keyframes obSlideIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:none}}`}</style>
    </div>
  );
}
